<template>
  <div class="register">
    <div class="registerForm">
      <div class="formtext">填写如下信息并提交完成注册</div>
      <div class="forminput">
        <div class="inputname"><span>*</span>姓名</div>
        <input v-model="name" type="text" placeholder="请输入姓名" ref="name">
      </div>
      <div class="forminput">
        <div class="inputname"><span>*</span>手机号</div>
        <input v-model="phone" type="text" placeholder="请输入手机号" ref="phone">
      </div>
      <div class="forminput">
        <div class="inputname"><span>*</span>邮箱</div>
        <input v-model="email" type="text" placeholder="请输入邮箱" ref="email">
      </div>
      <div class="forminput">
        <div class="inputname"><span>*</span>公司</div>
        <input v-model="company" type="text" placeholder="请输入公司" ref="company">
      </div>
      <div class="forminput">
        <div class="inputname"><span>*</span>行业</div>
        <input v-model="industry" type="text" placeholder="请输入行业" ref="industry">
      </div>
      <div class="btn" @click="onRegister">提  交</div>
    </div>
      
    
 </div>
</template>

<script>
import './register.css'
import { register } from '@/api/register.js'
export default {
  name: 'RegisterIndex',
  data () {
    return {
      name: '',
      phone: '',
      email: '',
      company: '',
      industry: '',
      focusState: false
    }
  },
  props: {},
  components: {},
  mounted () {},
  methods: {
    onRegister() {
      const user = {
        name: this.name,
        phone: this.phone,
        email: this.email,
        company: this.company,
        industry: this.industry
      }
      if(user.name == '') {
        alert('姓名不能为空')
        this.$nextTick(() => {
          this.$refs.name.focus()
        })
        return false
      }
      if(user.phone == '') {
        alert('手机号不能为空')
        this.$nextTick(() => {
          this.$refs.phone.focus()
        })
        return false
      } else {
        if(!(/^1[3456789]\d{9}$/.test(user.phone))){
          alert('请输入正确的手机号码')
          this.$nextTick(() => {
          this.$refs.phone.focus()
          })
          return false
        } 
      }
      if(user.email == '') {
        alert('邮箱不能为空')
        this.$nextTick(() => {
          this.$refs.email.focus()
        })
        return false
      } else {
        const reg = new RegExp("^([A-z0-9_\.-]+)@([\dA-z\.-]+)\.([A-z\.]{2,6})$");
        if(!reg.test(user.email)){
          alert('请输入正确的邮箱地址')
          this.$nextTick(() => {
          this.$refs.email.focus()
          })
          return false
        } 
      }
      if(user.company == '') {
        alert('公司名不能为空')
        this.$nextTick(() => {
          this.$refs.company.focus()
        })
        return false
      }
      if(user.industry == '') {
        alert('行业不能为空')
        this.$nextTick(() => {
          this.$refs.industry.focus()
        })
        return false
      }
    //  console.log(user)
      register(user).then(res => {
      //  console.log(res)
       if(res.data.code == 200) {
          alert('注册成功')
          this.$router.push('/')
       } else {
         alert('注册失败')
       }
       
        
      })
    }
  }
}
</script>

<style scoped lang='less'>
</style>
